<template>
    <div class="depoimentos-container">
        <h1>Depoimentos</h1>
        <b-carousel ref="depoimentosCarousel" v-bind="depoimentosCarouselProperties">
            <b-carousel-slide v-for="depoimento in depoimentos">
                <div class="depoimentosCarousel-elements">
                    <div class="depoimentosCarousel-quoteContainer"><img v-bind="quote" /></div>
                    <h5>{{depoimento.texto}}</h5>
                    <img v-bind="imgDepoimentoProperties" :src="getDepoimentoImg(depoimento.imgUrl)" />
                    <div class="depoimentosCarousel-depoimento-about">
                        <h3>{{depoimento.nome}}</h3>
                        <h4>{{depoimento.descricao}}</h4>
                    </div>
                </div>
            </b-carousel-slide>
        </b-carousel>
    </div>
</template>
<script>
import { CarouselPlugin } from 'bootstrap-vue';
export default {
   components: {CarouselPlugin},
    data() {
        return {
            depoimentosCarouselProperties:{
                controls: true,
                interval: 0,
            },
            imgDepoimentoProperties:{
                style:{
                    'height': '162px',
                    'width': '162px',
                    'object-fit': 'cover',
                    'margin-right':'30px'
                },
            },
            quote: {
                style: {
                    'width': '100px',
                    'padding': '4px 6px 0px 8px',
                    'rotate': '180deg',
                },
                src: this.getDepoimentoImg('quote_597EB5.svg')
            },
            depoimentos:[
                {
                    imgUrl:'ana-carolina.png',
                    // texto:'Quisque quis posuere sem. Integer nibh diam, tincidunt mattis tincidunt a, convallis ut mauris. Morbi scelerisque libero sit amet mauris pretium, at cursus augue sodales. Vivamus maximus et dui at rutrum.',
                    texto:'é um relevante instrumento para a Procuradoria-Geral do Estado assegurar eficiência na recuperação dos créditos não tributários do Estado de Goiás.',
                    nome:'Ana Carolina S. Rios Chaer',
                    descricao:'Procuradora do Estado Gerente da Dívida Ativa'
                },
                {
                    imgUrl:'daniel-farias.png',
                    texto:'veio para facilitar tanto para nos empresário como para os eventuais devedores; pois ganhamos tempo, diminuímos custos e facilitamos a vida do nosso cliente.',
                    nome:'Daniel de Moura Nogueira',
                    descricao:'Imobiliária Irmãos Nogueira'
                },
                {
                    imgUrl:'rafael-mota.png',
                    texto:'auxilia o Poder Público para reaver seus créditos de modo ágil, transparente, econômico e seguro. Atendendo ao interesse público.',
                    nome:'Rafael Mota Queiroz',
                    descricao:'Procurador Fiscal da Prefeitura de Belém'
                },
                {
                    imgUrl:'manhattan-fomento-mercantil.png',
                    texto:'Com o Cadastro muito prático: Protesto de cheques e Duplicadas sem intermediário(s): sem "altas" despesas (tarifas) a pagar; de fácil acesso, através do navegador de internet; eficientes no atendimento pessoal - quando precisamos!',
                    nome:'Alessandro Ayres',
                    descricao:'Gerente Operacional da Manhattan Fomento Mercantil'
                },
            ],
        };
    },
    methods: {
        getDepoimentoImg(imageSrc) {
            if (imageSrc.includes('svg')) {
                var images = require.context('../../assets/imgs/', false, /\.svg$/);
            } else {
                var images = require.context('../../assets/imgs/testimony/', false, /\.png$/);
            }
            return images('./' + imageSrc)
        },
    }
}
</script>
<style scoped>
    .depoimentos-container {
        width:100%;
        padding: 111px 73px 207px 73px;
    }
    .depoimentos-container h1{
        text-align: center;
        font: normal normal bold 30px/41px 'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #597EB5;
        text-transform: none;
        margin-bottom: 82px;
    }
    .depoimentos-container .depoimentosCarousel-elements{
        display: flex;
        height: 162px;
        align-items: center;
        justify-content: center;
    }
    .carousel-item {
        height: unset !important;
    }
    .depoimentos-container .depoimentosCarousel-elements .depoimentosCarousel-quoteContainer{
        width: 100px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 2.65vw;
    }
        
    /* .carousel-caption{
        height: 175px !important;
        padding: 0 !important;
        position: unset !important;
    } */
    .depoimentosCarousel-depoimento-about{
        display: flex;
        flex-flow: column;
        width: 200px;
    }
    .depoimentos-container .depoimentosCarousel-depoimento-about h3{
        text-align: left;
        font: normal normal bold 15px/20px  'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #597EB5;
        text-transform: none;
    }
    .depoimentos-container .depoimentosCarousel-depoimento-about h4{
        text-align: left;
        font: normal normal normal 15px/20px 'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #597EB5;
        text-transform: none;
    }
    .depoimentos-container h5{
        text-align: left;
        font: normal normal normal 20px/27px 'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #597EB5;
        text-transform: none;
        width: 422px;
        margin: 0;
        margin-right: 6.61vw;
    }
    @media (max-width: 1600px) and (min-width: 1500px){
        .depoimentos-container h5{margin-right: 2.61vw;}
        .depoimentos-container .depoimentosCarousel-elements .depoimentosCarousel-quoteContainer{margin-right: 1.95vw;}
    }
    @media (max-width: 1499px) and (min-width: 1200px){
        .depoimentos-container .depoimentosCarousel-elements{height: 190px;}
        .depoimentos-container h5{font-size: 1rem;margin-right: 1.51vw;}
        .depoimentos-container .depoimentosCarousel-elements .depoimentosCarousel-quoteContainer{margin-right: 0.95vw;}
    }
    @media (max-width: 1600px) and (min-width: 1400px) {
        .depoimentos-container{padding-left: 20px !important;padding-right: 20px !important;}
    }
    @media (max-width: 1399px) and (min-width: 1200px){
        .depoimentos-container{padding-left: 10px !important;padding-right: 10px !important;}
    }
    @media (max-width: 1199px){
        .depoimentos-container h1{display: none;}
        .depoimentos-container{padding:28px 34px 83px 34px;}
        .depoimentos-container .depoimentosCarousel-elements{height: fit-content;flex-flow: column;}
        .depoimentos-container .depoimentosCarousel-elements .depoimentosCarousel-quoteContainer{margin-right: 0;}
        .depoimentos-container h5{margin-right: 0;margin-bottom: 34px;font: normal normal normal 15px/20px 'Kanit', sans-serif;max-width: 286px;text-align: center;}
        .depoimentos-container .depoimentosCarousel-elements > img{margin-right: 0 !important;margin-bottom: 27px;width: 149px !important;height: 149px !important;}
        .depoimentosCarousel-depoimento-about > *{text-align: center !important;margin-bottom: 0;}
        .depoimentosCarousel-depoimento-about h3{margin-bottom: 20px;}
    }
</style>